import { useState, useEffect } from 'react';

// Cache the result globally to avoid recalculation
let cachedDeviceInfo = null;

const useDeviceDetection = () => {
  const [deviceInfo, setDeviceInfo] = useState(() => {
    // If we already have cached info, use it
    if (cachedDeviceInfo) {
      return cachedDeviceInfo;
    }
    
    // Otherwise, detect once
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    const isMobile = mobileRegex.test(userAgent);
    
    const result = { isMobile, isDesktop: !isMobile };
    cachedDeviceInfo = result; // Cache it
    return result;
  });

  // This useEffect will only run once when the component first mounts
  useEffect(() => {
    // Only detect if not already cached
    if (!cachedDeviceInfo) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobile = mobileRegex.test(userAgent);
      
      const result = { isMobile, isDesktop: !isMobile };
      cachedDeviceInfo = result;
      setDeviceInfo(result);
    }
  }, []); // Empty dependency array - runs only once

  return deviceInfo;
};

export default useDeviceDetection;